/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double the Celsius value and add 30 — it's close enough for weather chat, though not exact. 20°C doubled is 40, plus 30 is 70°F (the real answer is 68°F). For anything precise, like a recipe or a medical reading, use the exact formula instead of the shortcut.`)
};

const es_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplica el valor de Celsius y suma 30 — está lo suficientemente cerca para charla sobre el clima, aunque no es exacto. 20°C duplicado es 40, más 30 es 70°F (la respuesta real es 68°F). Para cualquier cosa precisa, como una receta o una lectura médica, usa la fórmula exacta en lugar del atajo.`)
};

const de_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdoppeln Sie den Celsius-Wert und addieren Sie 30 — das reicht für Small Talk über das Wetter, ist aber nicht exakt. 20°C verdoppelt sind 40, plus 30 sind 70°F (die tatsächliche Antwort ist 68°F). Für alles Präzise, wie ein Rezept oder einen medizinischen Messwert, verwenden Sie die exakte Formel statt der Faustregel.`)
};

const nl_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdubbel de Celsius-waarde en tel 30 op — het is dicht genoeg voor weerpraatjes, hoewel niet exact. 20°C verdubbeld is 40, plus 30 is 70°F (het werkelijke antwoord is 68°F). Voor alles wat nauwkeurig is, zoals een recept of medische aflezing, gebruikt u in plaats daarvan de exacte formule in plaats van de snelkoppeling.`)
};

const fr_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doublez la valeur Celsius et ajoutez 30 — c'est assez proche pour discuter du temps, mais pas exact. 20°C doublé est 40, plus 30 est 70°F (la vraie réponse est 68°F). Pour n'importe quoi de précis, comme une recette ou une lecture médicale, utilisez la formule exacte à la place du raccourci.`)
};

const it_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raddoppia il valore Celsius e aggiungi 30 — è abbastanza vicino per chiacchiere sul tempo, anche se non esatto. 20°C raddoppiato è 40, più 30 è 70°F (la risposta reale è 68°F). Per qualsiasi cosa precisa, come una ricetta o una lettura medica, usa la formula esatta anziché la scorciatoia.`)
};

const pt_br2_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobre o valor de Celsius e adicione 30 — é próximo o suficiente para conversa sobre o tempo, embora não exato. 20°C dobrado é 40, mais 30 é 70°F (a resposta real é 68°F). Para qualquer coisa precisa, como uma receita ou uma leitura médica, use a fórmula exata em vez do atalho.`)
};

const pt_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicar o valor Celsius e adicionar 30 — é suficientemente próximo para conversa de tempo, embora não exacto. 20°C duplicado é 40, mais 30 é 70°F (a resposta real é 68°F). Para qualquer coisa precisa, como uma receita ou uma leitura médica, utilize a fórmula exacta em vez do atalho.`)
};

const ja_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セルシウス値を2倍にして30を追加します — それは気象チャットに十分に近いですが、正確ではありません。20°C は2倍で40、30を加えると70°F です(実際の答えは68°Fです)。レシピまたは医学読書のような正確なもののため、近道ではなく正確な公式を使用します。`)
};

const zh_uc_temp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_temp_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_temp_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_temp_faq4_a", locale)
	if (locale === "en") return en_uc_temp_faq4_a(inputs)
	if (locale === "es") return es_uc_temp_faq4_a(inputs)
	if (locale === "de") return de_uc_temp_faq4_a(inputs)
	if (locale === "nl") return nl_uc_temp_faq4_a(inputs)
	if (locale === "fr") return fr_uc_temp_faq4_a(inputs)
	if (locale === "it") return it_uc_temp_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_temp_faq4_a(inputs)
	if (locale === "pt") return pt_uc_temp_faq4_a(inputs)
	if (locale === "ja") return ja_uc_temp_faq4_a(inputs)
	return zh_uc_temp_faq4_a(inputs)
};